import {
  BaseAnimationBuilder,
  FadeInDown,
  FadeInLeft,
  FadeInRight,
  FadeInUp,
  FadeOutDown,
  FadeOutLeft,
  FadeOutRight,
  FadeOutUp,
  LinearTransition,
  WithSpringConfig,
  WithTimingConfig
} from 'react-native-reanimated';
import { AnimationConfigBuilder } from 'react-native-reanimated/lib/typescript/layoutReanimation';

// TODO: import these from tamagui config. These still use tamagui v1 config
export const quick: WithSpringConfig = { damping: 20, mass: 1.2, stiffness: 250 };
export const quicker: WithSpringConfig = { damping: 20, mass: 0.7, stiffness: 250 };
export const quickest: WithSpringConfig = { damping: 8, mass: 0.2, stiffness: 200 };
export const bouncy: WithSpringConfig = { damping: 9, mass: 0.9, stiffness: 150 };
export const fast: WithTimingConfig = { duration: 100 };
export const medium: WithTimingConfig = { duration: 200 };
export const slow: WithTimingConfig = { duration: 400 };

const springAnimationMap = {
  quick,
  quicker,
  quickest,
  bouncy
} as const;

const durationAnimationMap = {
  fast,
  medium
} as const;

const createSpringTransition = (
  base: typeof AnimationConfigBuilder,
  animation: keyof typeof springAnimationMap = 'quicker'
) =>
  base
    .springify()
    .damping(springAnimationMap[animation].damping!)
    .mass(springAnimationMap[animation].mass!)
    .stiffness(springAnimationMap[animation].stiffness!);

const createDurationTransition = (
  base: typeof BaseAnimationBuilder,
  animation: keyof typeof durationAnimationMap
) => base.duration(durationAnimationMap[animation].duration!);

export const MediumTransition = createDurationTransition(LinearTransition, 'medium');
export const FastTransition = createDurationTransition(LinearTransition, 'fast');

export const QuickTransition = createSpringTransition(LinearTransition, 'quick');
export const QuickerTransition = createSpringTransition(LinearTransition);
export const QuickestTransition = createSpringTransition(LinearTransition, 'quickest');

export const FadeInLeftTransition = createSpringTransition(FadeInLeft);
export const FadeOutLeftTransition = createSpringTransition(FadeOutLeft);
export const FadeInRightTransition = createSpringTransition(FadeInRight);
export const FadeOutRightTransition = createSpringTransition(FadeOutRight);

export const FadeInDownTransition = createSpringTransition(FadeInDown);
export const FadeOutDownTransition = createSpringTransition(FadeOutDown);
export const FadeInUpTransition = createSpringTransition(FadeInUp);
export const FadeOutUpTransition = createSpringTransition(FadeOutUp);
